// document.addEventListener('DOMContentLoaded', function() {

  //  document.querySelectorAll('.product-badges .product-badge').forEach((badge) => {
  //     badge.innerText = "CHRISTMAS SALE";
  // });
  
  // const allowedBodyClass1 = 'collection-express-shipping';
  // const allowedBodyClass2 = 'template-product';

  // const bodyHasAllowedClass = document.body.classList.contains(allowedBodyClass1) && document.body.classList.contains(allowedBodyClass2);

  // if (!bodyHasAllowedClass) {
  // console.log("Both 'collection-express-shipping' and 'template-product' classes are not present");

  // const addToCartButton = document.querySelector('.template-product .product .product__details .product-form__item  .product-form__cart-submit');

  // if (addToCartButton) {
  //   console.log("add to cart button is present");

  //   addToCartButton.disabled = true; 
  //   addToCartButton.innerText = "Sold Out"; 
  //   addToCartButton.style.backgroundColor = "#1A1A1A";
  //   addToCartButton.style.Color = "#FFFFFF";    
  //   addToCartButton.style.cursor = "not-allowed"; 
    
  //   addToCartButton.classList.add('sold-out-cart-custom');
  //   }
  // }


  




// document.addEventListener('DOMContentLoaded', function() {
// var spanElement = document.querySelector('label[for="option1"] .cstm');


//     // var bdgLV = $('.collection-lv #shopify-section-template--23797772976510__product-grid .collection__container .collection__main-area .collection__products .product-item .product-badges .product-badge');
    
//     // bdgLV.each(function () {
//     //   $(this).html("WINTER SALE");
//     // });

//   // bad
//   // Check if the span contains the text "Color:"
// if (spanElement.innerHTML.trim().toLowerCase() === "color:") {
//     // Change the text to "Size:"
//     spanElement.innerHTML = "Size:";
// }
  
//   // Attach event listeners to the buttons
//   document.getElementById('uk-sizing').addEventListener('click', function() {
//     showVariants('UK');
//   });
//   document.getElementById('eu-sizing').addEventListener('click', function() {
//     showVariants('EU');
//   });

//   // Function to show variants based on region
//   function showVariants(region) {
//     var variants = document.querySelectorAll('.product__chip.dynamic-variant-button');
//     variants.forEach(function(variant) {
//       var span = variant.querySelector('span');
//       // if (span) {
//       //   span.innerHTML = span.innerHTML.replace(/UK|EU/g, '').trim(); // Remove "UK" or "EU" from the text
//       // }

//       if (variant.getAttribute('data-option-value').includes(region)) {
//         variant.style.display = 'block'; // Show the matching variants
//       } else {
//         variant.style.display = 'none'; // Hide the non-matching variants
//       }
//     });
//   }

//   // Show UK variants by default when the page loads
//   showVariants('UK');
// });





document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Safe Check for Span Element (Label Translation)
  var spanElement = document.querySelector('label[for="option1"] .cstm');
  if (spanElement) {
    if (spanElement.innerHTML.trim().toLowerCase() === "color:") {
        spanElement.innerHTML = "Size:";
    }
  }

  // 2. Sizing Logic Function
  function showVariants(region) {
    var variants = document.querySelectorAll('.product__chip.dynamic-variant-button');
    if (variants.length > 0) {
      variants.forEach(function(variant) {
        var dataValue = variant.getAttribute('data-option-value');
        if (dataValue && dataValue.includes(region)) {
          variant.style.display = 'block';
        } else {
          variant.style.display = 'none';
        }
      });
    }
  }

  // 3. Safe Event Listeners for Buttons
  var ukBtn = document.getElementById('uk-sizing');
  if (ukBtn) {
    ukBtn.onclick = function() {
      showVariants('UK');
    };
  }

  var euBtn = document.getElementById('eu-sizing');
  if (euBtn) {
    euBtn.onclick = function() {
      showVariants('EU');
    };
  }

  // 4. Default execution on page load
  showVariants('UK');

});



